import { render, staticRenderFns } from "./VFairDetails.vue?vue&type=template&id=15683636&scoped=true&"
import script from "./VFairDetails.vue?vue&type=script&lang=js&"
export * from "./VFairDetails.vue?vue&type=script&lang=js&"
import style0 from "./VFairDetails.vue?vue&type=style&index=0&id=15683636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15683636",
  null
  
)

export default component.exports